import { getData } from '@/utils/apiTools';
import { Industry } from '@/models/Tags';

// eslint-disable-next-line import/prefer-default-export
export const getIndustries = async (): Promise<Industry[]> => getData('/v1/tags/industries');
